const IconIntegration = () => {
    return (
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg">
            <path
                d="m9.33,13.74c0.19,0.31 0.42,0.61 0.67,0.88c1.63,1.7 4.1,1.98 6,0.79c0.35,-0.22 0.67,-0.47 0.98,-0.79l4.36,-4.56c1.92,-2.01 1.92,-5.28 0,-7.29c-1.92,-2.01 -5.06,-2.01 -6.98,0l-0.96,1"
                fill="none"
                stroke="currentColor"
                strokeWidth="2px"
            />
            <path
                d="m10.64,20.39l-0.96,1c-1.92,2.01 -5.06,2.01 -6.98,0c-1.92,-2.01 -1.92,-5.28 0,-7.29l4.36,-4.56c1.92,-2.01 5.04,-2.01 6.98,0c0.26,0.27 0.48,0.57 0.67,0.88"
                fill="none"
                stroke="currentColor"
                strokeWidth="2px"
            />
        </svg>
    );
};

export default IconIntegration;
